export async function waitForGoogleMaps(): Promise<typeof google.maps> {
    if (typeof google === 'undefined' || !google.maps?.importLibrary) {
        throw new Error('Google Maps API did not load in time.');
    }

    await google.maps.importLibrary('maps');
    await google.maps.importLibrary('marker');
    return google.maps;
}
